import request from '@/utils/request'

// 所有商户号总可用余额
export function mchAll(params) {
  return request({ url: '/webapi/mch/manageMch', method: 'get', params })
}

// 商户号详情
export function mchInfo(params) {
  return request({ url: '/webapi/mch/mchInfo', method: 'get', params })
}

// 商户号单日付款上限配置
export function mchTopPayConfig(data) {
  return request({ url: '/webapi/mch/mchTopPayConfig', method: 'post', data })
}

// 商户号支付区间配置
export function mchRangeConfig(data) {
  return request({ url: '/webapi/mch/mchRangeConfig', method: 'post', data })
}

// 商户号同一用户单日收款上限配置
export function mchDayPayConfig(data) {
  return request({ url: '/webapi/mch/mchDayPayConfig', method: 'post', data })
}

// 商户号同一用户单日收款次数配置
export function mchDayNumConfig(data) {
  return request({ url: '/webapi/mch/mchDayNumConfig', method: 'post', data })
}

// appid绑定商户号列表
export function appidBindMchList(params) {
  return request({ url: '/webapi/mch/appidBindMchList', method: 'get', params })
}

// appid绑定商户号
export function appidBindMch(data) {
  return request({ url: '/webapi/mch/appidBindMch', method: 'post', data })
}

// 撤销
export function rebackApply(data) {
  return request({ url: '/webapi/mch/rebackApply', method: 'post', data })
}

// appid导出
export function exportListAppid(data) {
  return request({ url: '/webapi/mch/exportList', method: 'post', data, responseType: 'blob' })
}// appid导出
export function appidDetail(params) {
  return request({ url: '/webapi/mch/appidDetail', method: 'get', params })
}

